<template>
  <van-overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="tour_content">
        <img class="tour_line" src="@/assets/images/tour_line.png" />
        <p>1. 点击右上角 “...”</p>
        <!-- <p>2. 分享到朋友圈或好友获得积分</p> -->
        <div class="tour_button" @click="close">
          <img src="@/assets/images/tour_button.png" />
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'SharePanel',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("close", false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tour_content {
  width: max-content;
  position: fixed;
  left: 50%;
  top: 80px;
  transform: translate(-50%, 0);
  color: #FFFFFF;
  font-size: 16px;
  .tour_line {
    width: 70px;
    margin-left: 60%;
  }
  p {
    margin-bottom: 30px;
  }
  .tour_button {
    width: 100%;
    height: 34px;
    margin: 40px auto 0;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>